module.exports = __webpack_public_path__ + "img/20190823165330494.7fb9c3ce.png";